import { createContext, useContext } from 'react';
import { DEFAULT_CONTENT, mergeContent } from '@/data/content';

const SiteContentContext = createContext(DEFAULT_CONTENT);

export function SiteContentProvider({ content, children }) {
  const merged = mergeContent(DEFAULT_CONTENT, content || {});
  return <SiteContentContext.Provider value={merged}>{children}</SiteContentContext.Provider>;
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}
